export const fileMimeMapper = {
  'application/pdf': 'application/pdf',
  'application/msword': 'application/doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'application/docx',
  'image/png': 'image/png',
  'image/jpg': 'image/jpg',
  'image/jpeg': 'image/jpeg'
};
export function fileSizeToMb(size) {
  return size / 1024 / 1024;
}
export function calculateTotalFileSize(files) {
  return files.reduce((acc, file) => acc + fileSizeToMb(file.size), 0);
}
export function getMimeExtension(mime) {
  let withDot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return "".concat(withDot ? '.' : '').concat(mime.split('/')[1]);
}
export function formatAcceptAttribute(allowedFileMimes, allowCamera) {
  const fileExtensions = allowedFileMimes.map(mime => getMimeExtension(mime));
  if (allowCamera) {
    return [...fileExtensions, 'capture=camera'].join(',');
  }
  return fileExtensions.join(',');
}
export function formatExtensionsDescription(allowedFileMimes) {
  const extensions = allowedFileMimes.map(mime => getMimeExtension(mime));
  return "".concat(extensions.slice(0, -1).join(', '), " ").concat(extensions.length > 1 ? 'en' : '', " ").concat(extensions.slice(-1)[0]);
}